<script setup lang="ts">
type TooltipProps = {
  location?: 'start' | 'end' | 'top' | 'bottom';
};

const props = defineProps<TooltipProps>();
const model = defineModel<boolean>();
</script>
<template>
  <v-tooltip
    v-model="model"
    :location="props.location || 'top'"
    activator="parent"
  >
    <slot />
  </v-tooltip>
</template>
